import { logError } from 'app/scripts/debug/log-error';
import { Feature } from 'app/scripts/debug/constants';
import {
  getOrLoadCardData,
  loadBoardData,
} from 'app/scripts/controller/display-card-loaders';

interface ShowCardDetailDialogOptions {
  setViewType?: (modelOrString: string) => void;
  onHide?: () => void;
}

export const showCardDetailDialog = async (
  idCardOrShortLink: string,
  { setViewType, onHide }: ShowCardDetailDialogOptions = {},
) => {
  let card;

  try {
    card = await getOrLoadCardData(idCardOrShortLink);
  } catch (err) {
    logError({
      error: err,
      tags: {
        ownershipArea: 'trello-remarkable',
        feature: Feature.CardDetailDialog,
      },
    });
  }

  if (!card) {
    return;
  }

  try {
    await loadBoardData(card.get('idBoard'), {
      loadLabels: true,
      loadExtraBoardData: true,
    });
  } catch (err) {
    logError({
      error: err,
      tags: {
        ownershipArea: 'trello-remarkable',
        feature: Feature.CardDetailDialog,
      },
    });
  }

  // Dependency required at call site to avoid import cycles, do not lift to top of module
  const CardDetailView = require('app/scripts/views/card/card-detail-view');

  const cardDetailView = new CardDetailView({
    modelCache: card.modelCache,
    model: card,
    notOnBoardView: true,
  });

  // Dependency required at call site to avoid import cycles, do not lift to top of module
  const Dialog = require('app/scripts/views/lib/dialog');

  if (setViewType) {
    setViewType(card);
  }

  Dialog.show({
    view: cardDetailView,
    hide: () => {
      // Dependency required at call site to avoid import cycles, do not lift to top of module
      const AttachmentViewer = require('app/scripts/views/internal/attachment-viewer');
      AttachmentViewer.clear();

      if (onHide) {
        onHide();
      }
    },
  });

  return cardDetailView;
};
